export const setPOListState = (payload) => {
    return {
        type: "SET_PO_LIST_STATE",
        payload
    };
};

export const clearPOListState = () => {
    return {
        type: "CLEAR_PO_LIST_STATE"
    };
};
